//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import { kAnonUsername, getCsrfToken } from "../session.js";

export default {
  data() {
    return {
      backdropEl: null,
    };
  },
  computed: {
    anonymousSession() {
      if (this.$sessionState) return this.$sessionState.loggedInAs === kAnonUsername;
      else return true;
    },
    userInfo() {
      if (this.$sessionState) {
        if (this.anonymousSession) {
          return this.$gettext("Trying out anonymously");
        } else {
          return this.$gettext("Logged in as") + ": " + this.$sessionState.loggedInAs;
        }
      } else {
        return "";
      }
    },
  },
  methods: {
    logout() {
      Vue.logout();
    },
    openSignup() {
      window.location.href = "/accounts/signup";
    },
    async inviteNewUser() {
      const email = prompt(
        this.$gettext(
          "Please send invitation only to people that expect them. " +
            "Don't spam people that didn't express interest in using " +
            "the application.\n\n" +
            "Provide email address to send the invitation to:"
        )
      );
      if (email == null) return; // Prompt cancelled.
      if (!/^\S+@\S+$/.test(email)) {
        const errText = this.$gettext("Not a correct email address");
        console.error(errText);
        alert(errText);
        return;
      }
      try {
        await Vue.http.post(
          "/send_invitation/",
          { email },
          {
            headers: { "X-CSRFToken": getCsrfToken() },
            emulateJSON: true,
          }
        );
        const successText = this.$gettext("Invitation sent!");
        console.info(successText);
        alert(successText);
      } catch (response) {
        console.error(response);
        const errText = `${response.statusText}: ${response.body}`;
        console.error(errText);
        alert(errText);
      }
    },
    showBackdrop() {
      if (!this.backdropEl) {
        this.backdropEl = document.createElement("div");
        this.backdropEl.classList.add("menu-backdrop");
        document.body.appendChild(this.backdropEl);
      }
    },
    removeBackdrop() {
      if (this.backdropEl) {
        this.backdropEl.remove();
        this.backdropEl = null;
      }
    },
  },
  beforeDestroy() {
    this.removeBackdrop();
  },
};
